import React, { useEffect, useState } from "react";
import style from "./rolePrivilege.module.css"
import PageHeader from "../../../components/pageHeader/pageHeader"
import DataTable from 'react-data-table-component';
import Sorting from '../../../assets/images/svgs/alphabetical-sorting.svg';
import Table, { tableCustomStyles } from "../../../components/CommonComponents/Table/Table";
import { useNavigate } from "react-router-dom";
import { ErrorToast } from "../../../components/toastMessage";
import axios from "axios";
import { BASE_URL } from "../../../constants/Constants";
import Dropdown from 'react-bootstrap/Dropdown';
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import Paginator, { PaginatorForRDT } from "../../../components/CommonComponents/Paginator/Paginator";
import EditButton, { ViewButton } from "../../../components/CommonComponents/EditComponent/EditComponent";
import { _axios } from "../../../utils/axios";

const RolePrivilege = () => {
  const [totalList, setTotalList] = useState(10);
  const [isGridView, setIsGridView] = useState(false);
  const [userRoleList, setUserRoleList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const formatDate = (dateString: string) => {
    if (!dateString) return '';
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const getUsers = () => {
    const requestData = {
      startDate,
      endDate
    };
    console.log("Request Data:", {
      startDate,
      endDate
    });
    _axios.get(`${BASE_URL}/api/role-privilages`, { params: requestData })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setUserRoleList(response.data.data);
        setTotalList(response.data.data.length);
        console.log('response', response);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getUsers()
  }, [startDate, endDate,])

  const columns = [
    {
      name: 'Sr. No.',
      // selector: (row: any, rowIndex: number | undefined) =>
      //   (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1,
      selector: (log: any, rowIndex: number | undefined) => {
        const serialNumber = (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1;
        return serialNumber.toString().padStart(3, '0');
      },
      sortable: false,
      grow: 0.5,
    },
    {
      name: 'Role Name',
      width: "400px",
      selector: (row: any) => row.role_name,
      sortable: true,
      grow: 2,
    },
    {
      name: 'Date',
      selector: (row: any) => formatDate(row.date ?? ''),
      sortable: true,
      width: "380px",
      grow: 1,
    },
    {
      name: 'Action',
      width: "200px",
      grow: 1,
      selector: (row: any) =>
        // <button
        //   onClick={() => {
        //     navigate(`/edit-role-privilege`, {
        //       state: { user: row },
        //     });
        //   }}
        //   className="icon-button"
        // >
        //   <i className="m-0 fa fa-eye"></i>
        // </button>,
        <div className="flex space-x-2">
          <EditButton
            disabled={true}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
          <ViewButton
            onClick={() => {
              navigate(`/edit-role-privilege`, {
                state: { user: row },
              });
            }}
          />
        </div>,
      sortable: false,
    },
  ];

  const handleDateFilterChange = (type: string, date: string) => {
    if (type === 'afterStartDate') {
      setStartDate(date);
    } else if (type === 'beforeEndDate') {
      setEndDate(date);
    }
  }

  const dropdownContent = (
    <div className={style.dropdownBox}>
      <ul>
        <Dropdown.Menu show className="align-left">
          <div className={style.dropContent}>
            <Dropdown.Header className={style.DropHeader}>Role Privilege filter</Dropdown.Header>

            <div className={style.dropdownContent}>
              <input
                type="date" placeholder="\u00A0"
                className={style.dropdownOption}
                onChange={(event) => handleDateFilterChange("afterStartDate", event.target.value)}
              />
              <label className={style.DropLabel}>After Start Date</label>
            </div>
            <div className={style.dropdownContent}>
              <input
                type="date" placeholder="\u00A0"
                className={style.dropdownOption}
                onChange={(event) => handleDateFilterChange("beforeEndDate", event.target.value)}
              />
              <label className={style.DropLabel}>Before End Date </label>
            </div>
          </div>
        </Dropdown.Menu>
      </ul>
    </div>
  );


  return (
    <div className={style.body}>
      <div className={style.bodybox}>
        <PageHeader
          title="Role Privileges"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={true}
          showAdditionalButton={false}
          buttonTitle=""
          isGridView={isGridView}
          onGridIconClick={() => setIsGridView(!isGridView)}
          showFilterButton={false}
          dropdownContent={dropdownContent}
        />
        {isGridView ?
          <BoxComponent>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              {userRoleList?.filter(
                (row: any) => row.role_name.toLowerCase().includes(searchQuery.toLowerCase()))
                .map((row: any) => {
                  return (
                    <div className="p-4 rounded-2xl bg-white flex flex-col shadow-lg border border-gray-300">
                      {/* <div className="flex justify-end items-start space-x-4 mb-4">
                        <button onClick={() => navigate('/edit-role-privilege', { state: { user: row } })} className="icon-button"><i className="m-0 fa fa-eye"></i></button>
                      </div> */}
                      <div className="flex justify-end items-center space-x-2 mb-4">
                        <EditButton
                          disabled={true}
                        />
                        <ViewButton
                          onClick={() => navigate('/edit-role-privilege', { state: { user: row } })}
                        />
                      </div>
                      <div className="mb-2 flex">
                        <p className="font-bold text-base w-1/2">Role Name</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{row?.role_name}</p>
                        {/* <button onClick={() => navigate('/edit-role-privilege', { state: { user: row } })} className="icon-button"><i className="m-0 fa fa-eye"></i></button> */}
                      </div>
                      {/* <div className="mb-2 flex">
                        <p className="font-bold text-base w-40 mr-4">Date</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{formatDate(row?.date ?? '')}</p>
                      </div> */}
                      <div className="mb-2 flex">
                        <p className="font-bold text-base w-1/2">Date</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{formatDate(row?.date ?? '')}</p>
                        <span className="icon-button" style={{ visibility: 'hidden' }}>
                          <i className="m-0 fa fa-eye"></i>
                        </span>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            <Paginator
              limit={entriesPerPage}
              page={currentPage}
              setPage={setCurrentPage}
              count={totalList || 0}
            />
          </BoxComponent>
          :
          <BoxComponent>
            <Table
              columns={columns}
              paginationComponent={PaginatorForRDT}
              customStyles={tableCustomStyles}
              data={userRoleList?.filter(
                (row: any) => row.role_name.toLowerCase().includes(searchQuery.toLowerCase()))
              }
            />
          </BoxComponent>
        }
      </div>
    </div>
  )
}

export default RolePrivilege;
